var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, Defaults, Utils, Watch, PropertyConverters, ViewChild, PCSS } from '@pacem/pacem-core';
import { ContenteditableUtils, ContenteditableDOMObserver } from './utils';
import { PacemContenteditableCommandElement } from '../contenteditable';
//namespace Pacem.Components.Scaffolding {
function insertPlaceholder(range, placeholder) {
    const ins = document.createElement('ins');
    ins.textContent = placeholder;
    ins.setAttribute('contenteditable', 'false');
    // not necessary:
    // ins.style.display = 'inline-block';
    ins.tabIndex = 0;
    range.deleteContents();
    range.insertNode(ins);
    return ins;
}
function isPlaceholder(node) {
    return node instanceof HTMLModElement && node.tagName === 'INS';
}
function isRelevant(range) {
    const wraps = ContenteditableUtils.testInertElementWrapping(range);
    if (wraps.result && isPlaceholder(wraps.element)) {
        const element = wraps.element, placeholder = element.textContent;
        return { result: true, element, placeholder };
    }
    return { result: false };
}
let PacemContenteditablePlaceholderElement = class PacemContenteditablePlaceholderElement extends PacemContenteditableCommandElement {
    constructor() {
        super(...arguments);
        this._focusHandler = (evt) => {
            const ins = evt.target;
            this.range = ContenteditableUtils.select(ins);
        };
        // #endregion
    }
    #relevancy;
    #normalizedDatasource;
    cleanUp(content) {
        content.querySelectorAll('ins[contenteditable=false]').forEach(ins => {
            Utils.removeClass(ins, 'placeholder-selected');
        });
    }
    exec(ph) {
        const el = insertPlaceholder(this.range, ph);
        const range = ContenteditableUtils.select(el);
        range.collapse(false);
        return Promise.resolve(el);
    }
    isRelevant(_) {
        return this.#relevancy?.result ?? false;
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._fillDropdown();
        this._initContainer();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'datasource':
                    this._fillDropdown();
                    break;
                case 'contentElement':
                    if (old) {
                        this._disposeContainer(old);
                    }
                    if (val) {
                        this._initContainer(val);
                    }
                    break;
                case 'range':
                    this._changeRelevancy();
                    break;
            }
        }
    }
    disconnectedCallback() {
        this._disposeContainer();
        super.disconnectedCallback();
    }
    _changeRelevancy(range = this.range) {
        const old = this.#relevancy;
        if (!Utils.isNull(old?.element)) {
            Utils.removeClass(old.element, 'placeholder-selected');
        }
        const val = this.#relevancy = isRelevant(range);
        if (!Utils.isNull(val?.element)) {
            Utils.addClass(val.element, 'placeholder-selected');
        }
        if (val.result) {
            this._dropdown.value = val.placeholder;
        }
        else {
            this._dropdown.popout();
            this._dropdown.value = void 0;
        }
    }
    _fillDropdown(datasource = this.datasource || []) {
        const ds = this.#normalizedDatasource = datasource.map(i => { return typeof i === 'string' ? { placeholder: i, definition: i } : i; });
        const dd = this._dropdown;
        dd.textProperty =
            dd.valueProperty = 'placeholder';
        dd.datasource = ds;
    }
    // #region mutation observer
    #observer;
    _initContainer(contentElement = this.contentElement) {
        this.#observer = new ContenteditableDOMObserver(contentElement, (item, removed) => {
            if (isPlaceholder(item)) {
                if (removed) {
                    this._downgradePlaceholderElement(item);
                }
                else {
                    this._enhancePlaceholderElement(item);
                }
            }
        }, 'ins[contenteditable=false]');
    }
    _disposeContainer(_ = this.contentElement) {
        const observer = this.#observer;
        if (!Utils.isNull(observer)) {
            observer.dispose();
        }
    }
    _enhancePlaceholderElement(ins) {
        ins.addEventListener('focus', this._focusHandler, false);
    }
    _downgradePlaceholderElement(ins) {
        ins.removeEventListener('focus', this._focusHandler, false);
    }
};
__decorate([
    ViewChild('template')
], PacemContenteditablePlaceholderElement.prototype, "_itemtemplate", void 0);
__decorate([
    ViewChild(P + '-suggest')
], PacemContenteditablePlaceholderElement.prototype, "_dropdown", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemContenteditablePlaceholderElement.prototype, "datasource", void 0);
PacemContenteditablePlaceholderElement = __decorate([
    CustomElement({
        tagName: P + '-contenteditable-placeholder', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<template>
<${P}-span text="{{ ^item.viewValue }}" class="text-tech"></${P}-span>
<${P}-markdown hide="{{ $pacem.isNullOrEmpty(^item.data.definition) || ^item.viewValue === ^item.data.definition }}" class="${PCSS}-margin margin-0 text-small" value="{{ ^item.data.definition }}"></${P}-markdown>
</template>
<${P}-suggest placeholder="Placeholder" class="pacem-button button" disabled="{{ $pacem.isNull(:host.range) }}"
              on-change=":host.execCommand($this.value)"
              css-class="{{ {'text-primary': :host.isRelevant(:host.range)} }}" 
              compare-by="placeholder" text-property="placeholder" itemtemplate="{{ ::_itemtemplate }}" prevent-focus="true" allow-typing="false"></${P}-suggest>`
    })
], PacemContenteditablePlaceholderElement);
export { PacemContenteditablePlaceholderElement };
